export default __webpack_public_path__ + "static/media/ico_cross.d4c1e647.svg";